module.exports = __webpack_public_path__ + "media/svg/map-marker-outline-4edb8323.svg";